import { get, post } from './http'
import setting from "@/setting";

let URL = setting.apiBaseURL

//获取角色列表
export const getRoles = () => get(URL + '/org/user/getCurrentUserRole');
//坐席配置-编辑
export const updateSeat = (data) => post(URL + '/rest/sysSeatsConfig/save', data);
//呼叫中心配置-编辑
export const updateCallCenter = (data) => post(URL + '/rest/sysCallConfig/save', data);
//短信模板-编辑
export const updateMsgTemplate = (data) => post(URL + '/rest/sysSmsTemplate/saveOrUpdate', data);
//示忙时间统计表 查询接口
export const agentState = (data) => post(URL + '/statistics/agentState', data);
//接通率及话务时间统计表 查询接口
export const agentCall = (data) => post(URL + '/statistics/agentCall', data);
//超时办结工单明细 查询接口
export const getOvertimeWorkOrder = (data) => post(URL + '/bus/order/getOvertimeWorkOrder', data);
//工单生成率统计 查询接口
export const orderGenInfo = (data) => post(URL + '/bus/order/orderGenInfo', data);
//承办单位办件统计 查询接口
export const orderOrgInfo = (data) => post(URL + '/bus/order/orderOrgInfo', data);
//签入签出统计
export const statistics = (data) => post(URL + '/bus/loginInfo/statistics', data);
// 用户收藏/取消收藏工单
export const collect = (data) => post(URL + '/rest/userCollectOrder/collect', data, true);
export const listJson = (data) => post(URL + '/rest/userCollectOrder/listJson', data, true);
export const saveList = (data) => post(URL + '/calendar/holidayConf/save', data);
export const collectionlist = (data) => post(URL + '/bus/kno-collection/page', data);
//工单统计（按来源） 查询接口
export const orderSourceInfo = (data) => post(URL + '/order/count/orderSource', data);
//话务量、接通率（按天
export const getCallAndConnectByDay = (data) => post(URL + '/bus/call/getCallAndConnectByDay', data);
//工单归口统计
export const orderCntByCaseAccordTypeOne = (data) => post(URL + '/bus/order/orderCntByCaseAccordTypeOne', data);